import type { RouteObject } from 'react-router';
import { LeadsPage } from '../leads/LeadsPage';

/** Independent rep agencies: the lead table scoped to reps. Their profiles stay at /leads/:id. */
export const routes: RouteObject[] = [{ path: '/reps', element: <LeadsPage kind="rep" /> }];
